import styled from 'styled-components';

export const LogoHolder = styled.div`
  padding: ${(props) => props.theme.spacing.spacing5};
`;
